var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(!_vm.isLoggedIn)?_c('StockRlogin'):_vm._e(),(_vm.isLoggedIn && this.$store.state.company.id)?_c('StockRstats'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }